import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import AsyncSelect from 'react-select/async'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import UpdateBloc from './Blocs/UpdateBloc'

class IndexView extends Component {

    source
    updateBloc = new UpdateBloc()

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            detailMenu: []
        }
    }

    submitData = async () => {
        const formData = {
            ...this.state.dataForm,
            id: this.props.id
        }
        await this.updateBloc.fetchUpdate(formData)
    }

    loadData = async () => {
        const query = {
            id: this.props.id
        }
        await this.updateBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const res = result.data.response
                    this.setState({ detailMenu: res })
                    break
                case apiResponse.ERROR:
                    console.log('cek', result)
                    break
                default:
                    break
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.updateBloc.detailChannel.unsubscribe()
        this.updateBloc.updateChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Menu Form</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Keterangan menu-menu. Lorem ipsum dolor sit amet...
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldParentID"
                                                className="col-md-3 col-form-label"
                                            >
                                                Parent ID
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="parent_id"
                                                    placeholder="Parent ID... (Default: 0)"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldParentID"
                                                    value={this.state.detailMenu && this.state.detailMenu.menu_parent_id}
                                                />
                                            </Col>
                                        </Row>
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="fieldParentID"
                                                className="col-md-3 col-form-label">
                                                Parent ID
                                            </label>
                                            <Col md="3">
                                                <AsyncSelect
                                                    cacheOptions
                                                    defaultOptions
                                                    isClearable
                                                    options={this.state.options}
                                                    // loadOptions={() => this.loadOptions()}
                                                />
                                            </Col>
                                        </Row> */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldName"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nama Menu
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="name"
                                                    placeholder="Nama Menu..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Menu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.detailMenu && this.state.detailMenu.menu_name}
                                                    id="fieldName"
                                                />  
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldUrl"
                                                className="col-md-3 col-form-label"
                                            >
                                                Url Menu
                                            </label>
                                            <Col md="9">
                                                <AvField 
                                                    name="url"
                                                    placeholder="Url Menu... (Default: #)"
                                                    type="text"
                                                    errorMessage="Masukkan Url Menu"
                                                    className="form-control"
                                                    value={this.state.detailMenu && this.state.detailMenu.menu_url}
                                                    id="fieldUrl"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldIcon"
                                                className="col-md-3 col-form-label"
                                            >
                                                Ikon Menu
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="icon"
                                                    placeholder="Icon Menu..."
                                                    type="text"
                                                    errorMessage="Masukkan Ikon Menu"
                                                    className="form-control"
                                                    value={this.state.detailMenu && this.state.detailMenu.menu_icon}
                                                    id="fieldIcon"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldSort"
                                                className="col-md-3 col-form-label"
                                            >
                                                Urutan
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="sort"
                                                    placeholder="Sort Menu..."
                                                    type="number"
                                                    errorMessage="Masukkan Urutan Menu"
                                                    value={this.state.detailMenu && this.state.detailMenu.menu_sort}
                                                    className="form-control"
                                                    id="fieldSort"
                                                />
                                            </Col>
                                        </Row>
                                        <Button color="primary" style={{ float: 'right' }} type="submit">
                                            Submit form
                                        </Button>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/setting/menu.html'/>
                : null }
            </Fragment>
        )
    }
}

export default IndexView